import { ILocation } from '@models/interfaces/ILocation';
import { CnuLocationFormatter } from '../cnu-location-formatter/cnu-location-formatter';

export class PcfLocationFormatter extends CnuLocationFormatter {
  format(location: ILocation): string[] {
    const line1: string = super.format(location)[0];

    const jsonMiscData = this.parseMiscData(location.LocationMiscData);

    const line2: string = this.renderMiscDataFields(location, jsonMiscData);
    const line3: string = this.renderMiscDataFields(location, jsonMiscData['Entree'], 'Mobile.Highway.Entrance');

    return [line1, line2, line3].filter(s => s);
  }

  private renderMiscDataFields(location: ILocation, jsonMiscData, prefixKey?: string): string {
    const lineFields: string = jsonMiscData
      ? [
          this.renderFields(['sFullText', 'Nom', 'refHighways_sName', 'refTracks_sName', 'refSectors_sName'], location, jsonMiscData),
          this.getKmPoint(jsonMiscData, 'Point_kilom')
        ]
          .filter(s => s)
          .join(', ')
      : '';
    return lineFields ? (prefixKey ? `${this.translate.instant(prefixKey)}: ${lineFields}` : lineFields) : '';
  }
}
